/* eslint-disable @stencil-community/required-jsdoc */
import { Component, Host, h, Prop, State, Listen } from '@stencil/core';
import { Memoize, parseIfString } from '@springbokagency/stencil-base';
import { VideoThumbnailGroup } from './video-thumbnail-group.types';
import checkWindowSize from '../../../utils/checkWindowSize';
import state from '../../../store/store';

@Component({
  tag: 'efb-video-thumbnail-group',
  styleUrl: 'video-thumbnail-group.scss',
  shadow: true,
})
export class EfbVideoThumbnailGroup {
  /**
   * State
   */
  @State() isMobile = checkWindowSize().isMobile;

  /**
   * Props
   */
  @Prop() theme?: 'dark' | 'light' = 'dark';

  @Prop() data: VideoThumbnailGroup | string;

  @Memoize('data')
  get parsedData(): VideoThumbnailGroup {
    return parseIfString(this.data);
  }

  /**
   * Events
   */

  @Listen('resize', { target: 'window' })
  handleWindowResize() {
    this.isMobile = checkWindowSize().isMobile;
  }

  /**
   * Render
   */

  render() {
    return (
      <Host>
        <div class={`video-thumbnail-group has-${this.theme}-theme`}>
          {/* Text */}
          <div class="text-wrapper">
            <efb-title-bar
              text={this.parsedData?.title}
              tag="h2"
              variant={this.theme === 'dark' ? 'pink' : 'purple'}
              bottomMargin="lg"
            />
            <efb-paragraph text={this.parsedData?.text} bottomMargin="lg" />
          </div>

          {/* Videos */}
          {this.parsedData.videos && (
            <div class="videos">
              {/* Standout video */}
              <div class="main-video">
                <efb-video-block {...this.parsedData.videos[0]} size="standout" />
              </div>

              {/* Other videos */}
              {this.parsedData.videos.length > 1 && (
                <div class="other-videos">
                  {/* Title */}
                  <p class="other-videos-title">
                    {state.currentLanguage === 'nl'
                      ? 'Bekijk alle video’s'
                      : 'Voir toutes les vidéos'}
                  </p>

                  {/* Video grid */}
                  <div class="video-grid">
                    {this.parsedData.videos
                      .slice(1, this.parsedData.videos.length)
                      ?.map((video) => (
                        <efb-video-block
                          {...video}
                          ratio={this.isMobile ? 'portrait' : 'square'}
                          size="thumbnail"
                        />
                      ))}
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </Host>
    );
  }
}
